import { render } from "./MessageButtons.vue?vue&type=template&id=14045e5b"
import script from "./MessageButtons.vue?vue&type=script&lang=js"
export * from "./MessageButtons.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__